var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){$event.stopPropagation();return _vm.openCourseCreateDialog($event)}}},[_vm._v("Создать курс")])}
var staticRenderFns = []

export { render, staticRenderFns }